<template>
  <div
    class="top-0 w-screen overflow-hidden bg-[#121212] flex justify-center"
    :class="{
      _drag: draggable,
      _no_drag: !draggable
    }"
  >
    <div
      class="text-white _no_drag flex justify-center items-center text-sm font-medium relative tracking-wide"
    >
      <template v-if="isHome">
        <div @click="showModal">表盘工具</div>
      </template>
      <!-- 编辑页面 -->
      <template v-else>
        <div class="cursor-pointer">
          <span @click="openWorkDir"> {{ watchName }}</span>
        </div>
        <div
          v-if="status == 'unsaved'"
          class="absolute w-[55px] left-full top-1/2 -translate-y-1/2 text-sm opacity-70"
        >
          -edited
        </div>
      </template>
    </div>
    <debug v-if="isDev" />
    <!-- 版本信息 -->
    <modal-app-version ref="appVersionRef" />
    <modal-new-version ref="newVersionRef" />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { ElectronApi } from '@/services/electron.api';
import { useWatchfaceStore } from '@/store/use-watchface-store';
import { useRoute } from 'vue-router';
import Debug from './Debug.vue';
import { status } from '@/hooks';
import { useEmitterListener } from '@/hooks';
import { EventType } from '@/utils/emitter.utils';
import { getEditorVersion } from '@/utils/version.utils';

const watchInfo = useWatchfaceStore();

const route = useRoute();
const isHome = computed(() => {
  return route.name == 'home';
});

const openWorkDir = async () => {
  await ElectronApi.showItemInFolder(watchInfo.path);
};

const isDev = import.meta.env.DEV;

const watchName = computed(() => watchInfo.description?.name);

// 版本信息
const appVersionRef = ref();
const showModal = () => {
  appVersionRef.value?.open?.();
};
useEmitterListener(EventType['modal:open-app-version'], () => {
  showModal();
});
// new version
const newVersionRef = ref();
useEmitterListener(EventType['modal:open-new-version'], () => {
  newVersionRef.value?.open?.();
});

let editorVersion = ref<string>('');
const platform = ref('darwin' as NodeJS.Platform);
onMounted(async () => {
  editorVersion.value = await getEditorVersion();
  platform.value = (await ElectronApi.getAppInfo()).platform ?? 'darwin';
});
const draggable = ref(true);
useEmitterListener(EventType['dropdown:visibleChange'], (visbile) => {
  draggable.value = !visbile;
});

// const openHelp = () => {
//   ElectronApi.shell?.openExternal('https://watchface.hyperos.mi.com/doc/');
// };

// 版本信息
</script>

<style scoped>
._drag {
  -webkit-app-region: drag;
}
._no_drag {
  -webkit-app-region: no-drag;
}
</style>
